import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutStepFormFields {

    public name: FormField
    public description: FormField
    public stepNumber: FormField
    public processStepAssociations: FormField
    public project: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )
        this.stepNumber = new FormField(
          'stepNumber',
          'Step number',
          null,
          FormFieldType.text,
          false,
        )
        this.processStepAssociations = new FormField(
          'processStepAssociations',
          'Process step associations',
          'processStepAssociation',
          FormFieldType.pushedSelectionList,
          false,
        )
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          false,
        )

    }
}

const fields = new PutStepFormFields()

export const putStepFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
  stepNumber: fields.stepNumber,
  processStepAssociations: fields.processStepAssociations,
  project: fields.project,
};